export default __webpack_public_path__ + "static/media/hospital3.b9f35fb5.svg";